import { render, staticRenderFns } from "./editClassify.vue?vue&type=template&id=f167d860&scoped=true&"
import script from "./editClassify.vue?vue&type=script&lang=js&"
export * from "./editClassify.vue?vue&type=script&lang=js&"
import style0 from "./editClassify.vue?vue&type=style&index=0&id=f167d860&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f167d860",
  null
  
)

export default component.exports